// extracted by mini-css-extract-plugin
module.exports = {"titleGroup":"members-module--titleGroup--3ry-T"};